import { render, staticRenderFns } from "./BtnIconAccept.vue?vue&type=template&id=4264c2d8"
import script from "./BtnIconAccept.vue?vue&type=script&lang=js"
export * from "./BtnIconAccept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports